
import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const LoginHistory: React.FC = () => {
  const [user, setUser] = useState<any | null>(null);

  useEffect(() => {
    const raw = localStorage.getItem('user_session');
    if (raw) {
      try {
        setUser(JSON.parse(raw));
      } catch {
        localStorage.removeItem('user_session');
      }
    }
  }, []);

  return (
    <Card className="w-full max-w-md mx-auto mt-6">
      <CardHeader>
        <CardTitle className="text-center">Authentication Information</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-center py-4">
          You are logged in using Supabase Authentication. Login history is now managed directly by Supabase.
        </p>
        {user?.role && (
          <div className="mt-4 p-4 bg-gray-50 rounded text-center">
            <p><strong>Current Role:</strong> {user.role}</p>
            <p><strong>Authorization Level:</strong> {user.auth_level || 'read'}</p>
            <p className="text-sm text-gray-500 mt-2">
              Your role determines which parts of the application you can access.
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
